import React, { useEffect, useState } from "react";
import { Modal, Button, Form, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CustomInput from "../../common/CustomInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { CreateFabric, UpdateFabric } from "../../../redux/actions/productActions";
import { RESET_ERROR } from "../../../redux/constants/userConstants";

const AddFabric = ({ openModal, onCloseModal, data, setActiveData, title }) => {
    const dispatch = useDispatch();
    const { newfabric, error } = useSelector(state => state.product);
    const [loading, setLoading] = useState(false);

    const schema = yup.object({
        name: yup.string()
            .matches(/^[A-Za-z0-9\s]+$/, "Fabric must contain only alphabets and numbers")
            .max(40, "Fabric must be at most 40 characters")
            .required("Fabric is required")
    });

    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            name: ''
        }
    });

    useEffect(() => {
        if (data) {
            setValue("name", data?.name);
        }
    }, [data]);

    useEffect(() => {
        if (newfabric) {
            reset();
        }
    }, [newfabric]);

    useEffect(() => {
        if (error) {
            dispatch({ type: RESET_ERROR });
        }
    }, [error]);

    const saveFabric = (formValues) => {
        setLoading(true);
        const payload = new FormData();
        payload.append('name', formValues.name);
        if (data?._id) {
            payload.append('id', data?._id);
            payload.append('status', data?.status);
        }
        const action = data ? UpdateFabric : CreateFabric;
        dispatch(action(payload)).finally(() => setLoading(false));
    };

    const clearclose = () => {
        setActiveData(null);
        onCloseModal();
        reset();
    };

    return (
        <Modal isOpen={openModal} toggle={clearclose}>
            <ModalHeader toggle={clearclose}>
                <h5 className="modal-title f-w-600">
                    {title}
                </h5>
            </ModalHeader>
            <ModalBody>
                <Form>
                    <CustomInput
                        fieldLabel='Fabric :'
                        control={control}
                        error={errors.name}
                        fieldName='name'
                    />
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button
                    type="button"
                    disabled={loading}
                    color="primary"
                    onClick={handleSubmit(saveFabric)}
                >
                    {loading ? "Saving" : "Save"}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AddFabric;

